var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 140,
    viewBox: "0 0 126 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0282 20.6064C44.0282 15.3009 48.3098 11 53.5916 11H116.437C121.718 11 126 15.3009 126 20.6064V123.532C126 128.837 121.718 133.138 116.437 133.138H53.5916C48.3098 133.138 44.0282 128.837 44.0282 123.532V20.6064Z",
    fill: "#9976BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 27.4681C29 22.1626 33.2817 17.8617 38.5634 17.8617H109.606C114.887 17.8617 119.169 22.1626 119.169 27.4681V130.394C119.169 135.699 114.887 140 109.606 140H38.5634C33.2817 140 29 135.699 29 130.394V27.4681Z",
    fill: "#DFBAF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5211 36.7314C64.5211 35.405 65.5915 34.3298 66.912 34.3298C68.2324 34.3298 69.3028 35.405 69.3028 36.7314C69.3028 38.0577 68.2324 39.133 66.912 39.133C65.5915 39.133 64.5211 38.0577 64.5211 36.7314Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0352 36.7314C72.0352 35.405 73.1056 34.3298 74.4261 34.3298H105.849C107.169 34.3298 108.239 35.405 108.239 36.7314C108.239 38.0577 107.169 39.133 105.849 39.133H74.4261C73.1056 39.133 72.0352 38.0577 72.0352 36.7314Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5211 45.6516C64.5211 44.3252 65.5915 43.25 66.912 43.25C68.2324 43.25 69.3028 44.3252 69.3028 45.6516C69.3028 46.978 68.2324 48.0532 66.912 48.0532C65.5915 48.0532 64.5211 46.978 64.5211 45.6516Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0352 45.6516C72.0352 44.3252 73.1056 43.25 74.4261 43.25H105.849C107.169 43.25 108.239 44.3252 108.239 45.6516C108.239 46.978 107.169 48.0532 105.849 48.0532H74.4261C73.1056 48.0532 72.0352 46.978 72.0352 45.6516Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5211 54.5718C64.5211 53.2454 65.5915 52.1702 66.912 52.1702C68.2324 52.1702 69.3028 53.2454 69.3028 54.5718C69.3028 55.8982 68.2324 56.9734 66.912 56.9734C65.5915 56.9734 64.5211 55.8982 64.5211 54.5718Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0352 54.5718C72.0352 53.2454 73.1056 52.1702 74.4261 52.1702H105.849C107.169 52.1702 108.239 53.2454 108.239 54.5718C108.239 55.8982 107.169 56.9734 105.849 56.9734H74.4261C73.1056 56.9734 72.0352 55.8982 72.0352 54.5718Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1972 68.2952C37.1972 66.9688 38.2676 65.8936 39.588 65.8936H105.849C107.169 65.8936 108.239 66.9688 108.239 68.2952C108.239 69.6216 107.169 70.6968 105.849 70.6968H39.588C38.2676 70.6968 37.1972 69.6216 37.1972 68.2952Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1972 80.6463C37.1972 79.3199 38.2676 78.2447 39.588 78.2447H105.849C107.169 78.2447 108.239 79.3199 108.239 80.6463C108.239 81.9726 107.169 83.0479 105.849 83.0479H39.588C38.2676 83.0479 37.1972 81.9726 37.1972 80.6463Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1972 92.9973C37.1972 91.671 38.2676 90.5957 39.588 90.5957H105.849C107.169 90.5957 108.239 91.671 108.239 92.9973C108.239 94.3237 107.169 95.3989 105.849 95.3989H39.588C38.2676 95.3989 37.1972 94.3237 37.1972 92.9973Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4 30.5958C59.4 46.4175 46.5416 59.2515 30.67 59.2515C14.7984 59.2515 1.94 46.4175 1.94 30.5958C1.94 14.774 14.7984 1.94 30.67 1.94C46.5416 1.94 59.4 14.774 59.4 30.5958Z",
    fill: "url(#paint0_linear_13699_439354)",
    stroke: "white",
    strokeWidth: 3.88
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6854 43.6088C40.3569 45.9317 37.3901 47.5136 34.1604 48.1545C30.9306 48.7954 27.5828 48.4665 24.5404 47.2093C21.498 45.9522 18.8977 43.8233 17.0681 41.0918C15.2386 38.3604 14.2621 35.1491 14.2621 31.864C14.2621 28.5789 15.2386 25.3676 17.0681 22.6361C18.8977 19.9047 21.498 17.7758 24.5404 16.5186C27.5828 15.2615 30.9306 14.9325 34.1604 15.5734C37.3902 16.2143 40.3569 17.7962 42.6854 20.1191",
    stroke: "white",
    strokeWidth: 3.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2812 12.7056L42.6843 20.1193L34.9556 21.8757",
    stroke: "white",
    strokeWidth: 3.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13699_439354",
    x1: -41.9102,
    y1: 50.0449,
    x2: 55.999,
    y2: 6.83907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.139053,
    stopColor: "#8927EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ABEFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadPageIcon);
export default __webpack_public_path__ + "static/media/reload-page-icon.362886240ba6e24d51c3548ae38a5c10.svg";
export { ForwardRef as ReactComponent };